import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const SET = 'info.SET';
const SET_INIT = 'info.SET_INIT';
const LEARNING_HISTORY_SET = 'LEARNING_HISTORY_SET';

/**
  * userInfo
  * @param {string} entryType: 진입한 APP 타입 (GM, GM_APP, 매쓰피드는 미정)
  * @param {string} channelCode: 채널코드
  * @param {string} contractNum: 계약번호
  * @param {string} locale: 언어
  * @param {string} userCode: 부모회원코드
  * @param {string} userId: 회원아이디
  * @param {string} userEmail: 회원이메일
  * @param {string} learnerCode: 자녀회원코드
  * @param {string} learnerId: 학습회원 ID
  * @param {string} guestLearnerId: 게스트 로그인 후 받은 학습회원 ID
  * @param {string} learnerBirth: 생년월일
  * @param {string} learnerSex: 성별
  * @param {string} learnerName: 회원이름
  * @param {string} pmCheck: PM공지 확인
  * @param {string} emailCertYn: APP 계정신청 유무
  * @param {string} iconImage: 회원 ICON 이미지
  * @param {string} className: 채널별 clsssname
  * @param {string} terms: 약관 동의 유무
  * @param {string} privacy: 개인정보 수집 동의 유무
  * @param {string} adult: 만 14세 이상 동의 유무
  * @param {string} marketing: 마케팅 동의 유무
  * @param {string} memberType: 생성/조회된 계정 타입 (GUEST:게스트, MEMBER:회원가입)
  * @param {string} rgtnDt: 사용자 등록일
  * @param {string} subscribing: 플레이스토어구독결제여부
  * @param {string} storeProductID: 플레이스토어상품ID
  * @param {string} storeProductCode: 플레이스토어상품코드
  * @param {string} countryCd: 국가코드
  * @param {boolean} isPaymentCountry: 결제가능국가여부
  * @param {boolean} subScriptionPurchsYn: 구독결제여부
  * @param {Array} learner: 학습자녀들
  * @param {Array} isMember: 학습회원 여부
  * 
  * learningHistory
  * @param {string} isTutorial: 튜토리얼 확인여부
  * @param {string} isCompleteAIDiagnosis: 진단이력 완료 여부
  * @param {string} isCheckAIDiagnosisResult: 진단이력 결과페이지 확인 여부
  * @param {string} isLastLearningStage: 마지막학습결과 여부
  * @param {string} enterViewPath : 진입화면경로
  * 마지막학습이력,
  * default 주제학습이력
  */

export const setInfo = createAction(SET, (data) => data);
export const setInit = createAction(SET_INIT);
export const setLearningHistory = createAction(LEARNING_HISTORY_SET, (data) => data);

const defaultState = {
  info: null,
  learningHistory: null,
};

const info = handleActions(
  {
    [SET]: (state, { payload: info }) => {
      return produce(state, draft => {
        draft.info = {
          ...state.info,
          ...info
        }
      })
    },
    [SET_INIT]: (state, {payload: info}) => {
      return produce(state, draft => {
        draft.info = defaultState.info
      }) 
    },
    [LEARNING_HISTORY_SET]: (state, { payload: history }) => {
      // console.log({ state, history });
      return produce(state, draft => {
        draft.learningHistory = {
          ...state.learningHistory,
          ...history
        };
      })
    }
  },
  defaultState
);

export default info;
